const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'acrechain',
            client_id: '07-tendermint-11',
            connection_id: 'connection-12'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-101',
            connection_id: 'connection-89'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-77',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'akash',
            client_id: '07-tendermint-173',
            connection_id: 'connection-159'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-387',
            connection_id: 'connection-364'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-116',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-273',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-15',
            connection_id: 'connection-11'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-409',
            connection_id: 'connection-413'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-351',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'archway',
            client_id: '07-tendermint-42',
            connection_id: 'connection-47'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-384',
            connection_id: 'connection-360'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-50',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-265',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-39',
            connection_id: 'connection-21'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-7',
            connection_id: 'connection-10'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-11',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-6',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'carbon',
            client_id: '07-tendermint-33',
            connection_id: 'connection-16'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-66',
            connection_id: 'connection-54'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-36',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'demex'
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-16',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-41',
                    port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'celestia',
            client_id: '07-tendermint-53',
            connection_id: 'connection-16'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-391',
            connection_id: 'connection-381'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-15',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-300',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cheqd',
            client_id: '07-tendermint-83',
            connection_id: 'connection-61'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-392',
            connection_id: 'connection-382'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-34',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-301',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'comdex',
            client_id: '07-tendermint-117',
            connection_id: 'connection-56'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-70',
            connection_id: 'connection-59'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-51',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-39',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-760',
            connection_id: 'connection-551'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-0',
            connection_id: 'connection-1'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-339',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'crescent',
            client_id: '07-tendermint-36',
            connection_id: 'connection-37'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-68',
            connection_id: 'connection-57'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-27',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-37',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'crescent'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'decentr',
            client_id: '07-tendermint-26',
            connection_id: 'connection-10'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-395',
            connection_id: 'connection-385'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-315',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'dydx',
            client_id: '07-tendermint-9',
            connection_id: 'connection-14'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-390',
            connection_id: 'connection-380'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-299',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-2',
            connection_id: 'connection-1'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-385',
            connection_id: 'connection-361'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-271',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'injective',
            client_id: '07-tendermint-216',
            connection_id: 'connection-202'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-369',
            connection_id: 'connection-311'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-151',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-255',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'juno',
            client_id: '07-tendermint-185',
            connection_id: 'connection-128'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-3',
            connection_id: 'connection-6'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-86',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kava',
            client_id: '07-tendermint-156',
            connection_id: 'connection-196'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-386',
            connection_id: 'connection-362'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-138',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-272',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kujira',
            client_id: '07-tendermint-5',
            connection_id: 'connection-3'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-11',
            connection_id: 'connection-13'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-5',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-10',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-36',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-28',
                    port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'mars',
            client_id: '07-tendermint-10',
            connection_id: 'connection-6'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-104',
            connection_id: 'connection-91'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-78',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'migaloo',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-105',
            connection_id: 'connection-93'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-86',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-87',
                    port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'neutron',
            client_id: '07-tendermint-12',
            connection_id: 'connection-9'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-274',
            connection_id: 'connection-192'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-25',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-229',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-5',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-167',
                    port_id: 'wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-6',
                    port_id: 'wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07'
                },
                chain_2: {
                    channel_id: 'channel-168',
                    port_id: 'wasm.terra1fkuhmq52pj08qqffp0elrvmzel8zz857x0pjjuuaar54mgcpe35s9km660'
                },
                ordering: 'unordered',
                version: 'astroport-ibc-v1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'noble',
            client_id: '07-tendermint-56',
            connection_id: 'connection-54'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-367',
            connection_id: 'connection-302'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-30',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-253',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-1979',
            connection_id: 'connection-1536'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-2',
            connection_id: 'connection-3'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-251',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-559',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-85',
                    port_id: 'wasm.terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-341',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-26',
                    port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-21671',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-392',
                    port_id: 'wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'secretnetwork',
            client_id: '07-tendermint-38',
            connection_id: 'connection-20'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-4',
            connection_id: 'connection-7'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-16',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    properties: 'privacy'
                }
            },
            {
                chain_1: {
                    channel_id: 'channel-127',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-382',
                    port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    properties: 'privacy'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'stafihub',
            client_id: '07-tendermint-5',
            connection_id: 'connection-5'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-317',
            connection_id: 'connection-233'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-204',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'stargaze',
            client_id: '07-tendermint-337',
            connection_id: 'connection-275'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-405',
            connection_id: 'connection-408'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-266',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-324',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'stride',
            client_id: '07-tendermint-51',
            connection_id: 'connection-32'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-87',
            connection_id: 'connection-72'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-52',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-46',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'terra',
            client_id: '07-tendermint-235',
            connection_id: 'connection-142'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-394',
            connection_id: 'connection-384'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-85',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-314',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    }
];
export default info;
